module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    staticStyle: {
      "height": "450px",
      "overflow": "hidden"
    }
  }, [_c('img', {
    staticStyle: {
      "margin": "0"
    },
    attrs: {
      "src": _vm.$root.urlsite + 'documenti/backHome.png'
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-18d05381"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Image-home.vue
// module id = 354
// module chunks = 0